import { render, staticRenderFns } from "./Update-password.vue?vue&type=template&id=371da0aa&scoped=true&"
import script from "./Update-password.vue?vue&type=script&lang=js&"
export * from "./Update-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371da0aa",
  null
  
)

export default component.exports